// extracted by mini-css-extract-plugin
export default {"container":"GP-z","title":"HP-z","link":"IP-z"};